import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_SERVER,
    prepareHeaders: async (headers, { getState, endpoint }) => {
        const token = getState()?.auth?.accessToken;
        if (token) {
            headers.set("Authorization", `Bearer ${token}`);
        }

        return headers;
    },
});

export const apiSlice = createApi({
    reducerPath: "api",
    baseQuery: async (args, api, extraOptions) => {
        let result = await baseQuery(args, api, extraOptions);

        if (result?.error?.status === 401) {
            // api.dispatch(userLoggedOut());
            //here should be logged out
            localStorage.clear();
        }
        return result;
    },
    tagTypes: [
        "Teams",
        "BacklogDatas",
        "ReadyDatas",
        "DoingDatas",
        "ReviewDatas",
        "BlockedDatas",
        "DoneDatas",
    ],
    endpoints: (builder) => ({}),
});
